/** API base URLs: use apiBaseAddress / dataApiBaseAddress here; UrlInterceptor replaces with env (single source in environment.*.ts). */
export const HTTPCONSTANTS = {
  plato_search_protocol: '[HTTP-PLATO-SEARCH-PROTOCOL]',
  plato_search_base: '[HTTP-PLATO-SEARCH-BASE]',
  platoProtocol: '[HTTP-PLATO-PROTOCOL]',
  protocol: '[HTTP-API-PROTOCOL]',
  apiBaseAddress: '[HTTP-API-BASE-ADDRESS]',
  dataApiProtocol: '[HTTP-DATA-API-PROTOCOL]',
  dataApiBaseAddress: '[HTTP-DATA-API-BASE-ADDRESS]',
  platoBaseAddress: '[HTTP-PLATO-BASE-ADDRESS]',
  // Editorial Intelligence ONLY. This is the isolated Dev2 Plato FastAPI/Lambda
  // HttpApi (NOT the .NET api-dev2 host). UrlInterceptor swaps these for env.
  editorialApiProtocol: '[HTTP-EDITORIAL-API-PROTOCOL]',
  editorialApiBaseAddress: '[HTTP-EDITORIAL-API-BASE-ADDRESS]',
  serverError: 'Something Went Wrong',
  incorrectLogin: 'Incorrect details, please try again.',
};
